

exports.__esModule = true;
exports.$xoPageAddFiPageComponent = undefined;

var _uiRouter = require('uiRouter');

var _angular = require('angular');

var _logger = require('xo-beaver/dist/logger');

var _squid = require('squid');

var _auth = require('xo-models/src/auth');

var _choice = require('xo-models/src/choice');

var _fiMessages = require('xo-models/src/fi/lib/fiMessages');

var _checkout = require('xo-models/src/checkout');

require('xo-validation/dist/directive');

require('xo-ui-components/src/dropdown/directive');

require('xo-ui-components/src/tooltip/directive');

require('xo-wallet-components/src/add-card/directive');

require('xo-page-components/src/value-props/directive');

var _template = require('./template');

var _template2 = _interopRequireDefault(_template);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var $xoPageAddFiPageComponent = exports.$xoPageAddFiPageComponent = _squid.$Component.extend('$xoPageAddFiPageComponent', {
    tag: 'xo-page-add-fi-page',
    template: _template2['default'],
    scope: {
        logout: '=?'
    },
    controller: ['$scope', function ($scope) {
        $scope.token = _angular.$rootScope.token;
        $scope.locale = _squid.$locale;
        $scope.billingaddressupdated = {
            value: false
        };
        $scope.hideparenthead = {
            toggle: false
        };
        $scope.title = _squid.$locale.content.get('addCard.addACard');
        $scope.callbacks = {
            finish: function finish() {
                return _uiRouter.$state.go('checkout.review');
            },
            done: function done() {
                return _uiRouter.$state.go('checkout.review');
            },
            cancel: function cancel(routeTo) {
                var destination = routeTo || $scope.parentState || '';

                if (destination) {
                    _uiRouter.$state.go(destination);
                }
            }
        };

        var models = {};

        (0, _squid.$populate)($scope, {
            auth: _auth.$AuthModel.instance(),
            payee: _checkout.$CheckoutPayeeModel.instance($scope.token)
        }).then(function () {
            $scope.logout = function () {
                _logger.$logger.info('not_you_logout');
                $scope.auth.logoutAndRedirect('NOT_YOU');
            };
            $scope.showNotYou = $scope.auth && $scope.auth.showNotYou();

            (0, _squid.$populate)(models, {
                checkoutSession: _checkout.$CheckoutSessionModel.instance($scope.token)
            }).then(function () {
                return (0, _squid.$pxp)('xo_hermes_addcard_msg', { 'ctx.COUNTRY': $scope.locale.country }, 'xo_hermes_addcard_msg_treatment', false, true).then(function (result) {
                    var message = _fiMessages.$fiMessages.processorDeclinedMsg(models.checkoutSession, false);

                    // If no processor decline, retrieve and display the contingency message
                    if (!message && models.checkoutSession.get('errorData.cause')) {
                        if ($scope.payee.isGambling()) {
                            message = _fiMessages.$fiMessages.getGamblingMsg();
                        } else if (result) {
                            message = _fiMessages.$fiMessages.getAddCardTreatmentMsg(models.checkoutSession);
                        } else {
                            message = _fiMessages.$fiMessages.getAddCardControlMsg(models.checkoutSession);
                        }
                    }

                    if (message) {
                        $scope.pageLevel = $scope.pageLevel || {};
                        $scope.pageLevel.message = {
                            type: message.type,
                            msgs: [message.msg]
                        };
                        $scope.showHiMsg = true;
                        if (message.title) {
                            $scope.messagetitle = _squid.$locale.content.get(message.title.key);
                        }
                    }

                    return _choice.$ChoiceEligibility.instance().getVariant($scope.token).then(function (variant) {
                        var selectFiVariants = _squid.$config.choiceExperiment && _squid.$config.choiceExperiment.selectFi || [];
                        var displayCancelButton = selectFiVariants.indexOf(variant) > -1 && !message;

                        // show cancel button if no contingency
                        $scope.showCancel = displayCancelButton;
                        $scope.parentState = 'checkout.selectFi';
                    });
                });
            });
        });
    }]
});
angular.value("$xoPageAddFiPageComponent", $xoPageAddFiPageComponent);
_uiRouter.$state;

_angular.$rootScope;

_logger.$logger;

_squid.$Component;

_squid.$config;

_squid.$locale;

_squid.$populate;

_squid.$pxp;

_auth.$AuthModel;

_choice.$ChoiceEligibility;

_fiMessages.$fiMessages;

_checkout.$CheckoutPayeeModel;

_checkout.$CheckoutSessionModel;


//////////////////
// WEBPACK FOOTER
// ./pages/xo-add-fi/directive.js
// module id = ./pages/xo-add-fi/directive.js
// module chunks = 0